export const RBAC_PERMISSIONS = {
  READ: 'read',
  WRITE: 'write',
  DELETE: 'delete',
  MANAGE: 'manage'
} as const;

export type PermissionValue = typeof RBAC_PERMISSIONS[keyof typeof RBAC_PERMISSIONS];
export function permissionIncludes(has: PermissionValue, needs: PermissionValue): boolean {
  if (has === needs) return true;
  if (has === RBAC_PERMISSIONS.MANAGE) return true;
  return false;
}


